import React from "react";
import { TextWithLineBreaks } from "src/components";
import { Inbox } from "lucide-react";

interface NoDataDisplayProps {
  customMessage?: string;
}

const NoDataDisplay: React.FC<NoDataDisplayProps> = ({ customMessage }) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div className="w-16 h-16 rounded-full bg-secondary-100 flex items-center justify-center mb-4">
        <Inbox className="w-8 h-8 text-secondary-400" />
      </div>
      <p className="text-lg font-medium text-secondary-700">
        {customMessage ? <TextWithLineBreaks text={customMessage} /> : "No Data to Display..."}
      </p>
    </div>
  );
};

export { NoDataDisplay };
